import { LanguageService } from 'src/app/services';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private languageService : LanguageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = this.languageService.getCurrentLanguage();

    if (language) {
      const headers = req.headers.set('Accept-Language', language);
      const request = req.clone({ headers });
      return next.handle(request);
    }

    return next.handle(req);
  }
}
